import { defineNuxtLink } from '#imports'

export default defineNuxtLink({
    componentName: 'MiscDefineLink'
})
